/**
 * 用户中的数据库是否离职、加入失败等状态
 *
 */
export class UserLeaveStatusEnum{

    add (key, status,value) {
        // console.log("key ",key)
        this[key] = { status,value}
        return this
    }

}